<template>
  <div class="main-cont">
    <div class="coll-sel" v-if="userType === -1">
      <!-- <el-select v-model="deptId" placeholder="请选择学院" @change="deptChange">
        <el-option
          v-for="item in collegeList"
          :key="item.uuid"
          :label="item.deptName"
          :value="item.uuid"
        ></el-option>
      </el-select> -->
      <el-input
        class="dept_input"
        clearable
        placeholder="请选择工作单位"
        v-model="deptNames"
        @focus="showDeptModal"
        @clear="clearDepts">
      </el-input>
    </div>
    <el-tabs class="m-t-16" v-model="activeTab" type="card" @tab-click="changeTab">
      <el-tab-pane label="日活" name="0">
        <day-active :deptLevelCodes="deptLevelCodes" :userType="userType" />
      </el-tab-pane>
      <el-tab-pane label="月活" name="1" lazy>
        <month-active v-if="activeTab == '1'" :deptLevelCodes="deptLevelCodes" :userType="userType" />
      </el-tab-pane>
    </el-tabs>
    <SearchLazyTree ref="lazyTree" :deptDialog="deptDialog" @selectDept="selectDept"/>
  </div>
</template>

<script>
import { getItem } from "@/utils/storage";
import { topDeptList } from "@/api/dept";
import DayActive from "./dayActive.vue";
import MonthActive from "./monthActive.vue";
import SearchLazyTree from "./searchLazyTree.vue";

export default {
  name: "activityStatistics",
  components: {
    DayActive,
    MonthActive,
    SearchLazyTree,
  },
  data() {
    return {
      userType: getItem("userType"),
      load: false,
      activeTab: "0",
      defaultCheckedKeys: [],
      deptDialog: {
        flag: false
      },
      deptNames: "",
      deptLevelCodes: [],
    };
  },
  methods: {
    // 选择工作单位弹窗
    showDeptModal() {
      this.deptDialog.flag = true;
    },
    clearDepts() {
      this.defaultCheckedKeys = [];
      this.deptLevelCodes = [];
      this.$nextTick(()=> {
        this.$refs.lazyTree.$refs["tree"].setCheckedKeys(this.defaultCheckedKeys);
      })
    },
    // 工作单位选择确定
    selectDept(data) {
      this.deptLevelCodes = data.deptLevelCodes;
      this.defaultCheckedKeys = data.nodeKeys;
      this.deptDialog.flag = false;
    },
    changeTab(tab, event) {},
    initPage() {
      if (this.userType === -1) {
        topDeptList()
          .then(({ code, data }) => {
            if (code === 0) {
              this.collegeList = data;
              // 默认单位
              this.deptId = data[0].uuid;
              this.load = true;
            }
          })
          .catch(() => {});
      } else {
        this.load = true;
      }
    },
  },
  created() {
    // this.initPage();
  },
};
</script>

<style lang="scss" scoped>
.main-cont {
  padding: 20px 24px;
  .m-t-16 {
    margin-top: 16px;
  }
  .dept_input {
    width: 30%;
  }
}
</style>